import { render } from "./TopSideBar.vue?vue&type=template&id=066613c2"
import script from "./TopSideBar.vue?vue&type=script&lang=js"
export * from "./TopSideBar.vue?vue&type=script&lang=js"

import "./TopSideBar.vue?vue&type=style&index=0&id=066613c2&lang=css"

import exportComponent from "/var/www/karman/karman_crm/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__